import axiosService from '../axios.service';

const sessionDataService = {

  get(params) {
    let querystring = "";
    if (params.sessionDate) {
      querystring += `&sessionDate=${params.sessionDate}`
    }

    if (params.type.length > 0) {
      querystring += `&type=${params.type}`
    }

    return new Promise((resolve) => {
      axiosService.api.get(`/session?${querystring}`)
        .then(response => {
          resolve(response.data);
        })
    })
  },
}

export default sessionDataService
